import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, contentChild, input, TemplateRef } from '@angular/core';
import { RouterLink } from '@angular/router';
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';

export interface DetailItem {
  icon?: string;
  content: string;
  isHtml?: boolean;
}

@Component({
  selector: 'app-search-item-base',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, RouterLink, CardModule, ButtonModule],
  template: `
    @let _icon = icon();
    @let _color = color();
    @let _detailRouterLink = detailRouterLink();
    @let _detailItems = detailItems();

    @let _titleTemplate = titleTemplate();
    @let _codeTagTemplate = codeTagTemplate();

    <a class="flex flex-col gap-1 py-2 px-4" [routerLink]="_detailRouterLink">
      <div class="flex flex-row gap-3 items-center">
        @if (_icon) {
          <i [ngClass]="[_icon, _color || '', 'text-lg!']"></i>
        }

        <div class="flex flex-grow text-lg">
          @if (_titleTemplate) {
            <ng-container *ngTemplateOutlet="_titleTemplate" />
          }
        </div>

        @if (_codeTagTemplate) {
          <ng-container *ngTemplateOutlet="_codeTagTemplate" />
        }
      </div>

      <div class="flex items-baseline gap-3 text-sm">
        @for (item of _detailItems; track $index; let first = $first) {
          <div class="flex flex-row gap-1 items-center">
            @if (item.icon) {
              <i [ngClass]="[item.icon, 'text-sm!']"></i>
            }
            @if (!item.icon && !first) {
              <span> - </span>
            }

            @if (item.isHtml) {
              <div [innerHTML]="item.content"></div>
            } @else {
              {{ item.content }}
            }
          </div>
        }
      </div>
    </a>
  `,
  styles: ``,
})
export class SearchItemBaseComponent {
  readonly icon = input<string>();
  readonly color = input<string>();
  readonly detailRouterLink = input.required<string[]>();
  readonly detailItems = input.required<DetailItem[]>();

  readonly titleTemplate = contentChild<TemplateRef<unknown>>('title', { descendants: false });
  readonly codeTagTemplate = contentChild<TemplateRef<unknown>>('codeTag', { descendants: false });
}
